const Summary = ({ testData }) => {
  return (
    <div className="w-full rounded-lg px-3 pt-7 text-navy-800 dark:text-white md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Test Summary
        </h4>
      </div>
      <div className="mb-4">
        <p>
          <strong> Assigned to Course:</strong> {testData.courseName}
        </p>
      </div>
      <div className="mb-4">
        <p>
          <strong>Test Title:</strong> {testData.title}
        </p>
      </div>
      <div>
        {testData.questions.map((question, index) => (
          <div
            key={index}
            className="mb-3 rounded-xl border border-gray-100 p-2"
          >
            <h4 className="font-semibold">Question {index + 1}</h4>
            <p>
              <strong>Question Text:</strong> {question.questionText}
            </p>
            {testData.type === 'mcq' && (
              <div>
                <p>
                  <strong>Options:</strong>
                </p>
                <ul className="dark:text-navy-100">
                  {question.options.map((option, optionIndex) => (
                    <li key={optionIndex}>
                      Option {optionIndex + 1}: {option}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <p>
              <strong>Correct Answer:</strong> {question.correctAnswer}
            </p>
            <p>
              <strong>Mark:</strong> {question.marks}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Summary;
